import { render, staticRenderFns } from "./ItemListComponent.vue?vue&type=template&id=88796a2e&scoped=true"
import script from "./ItemListComponent.vue?vue&type=script&lang=js"
export * from "./ItemListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88796a2e",
  null
  
)

export default component.exports